import { render, staticRenderFns } from "./UsersPrivilegeServicesReservations.vue?vue&type=template&id=7e1031f7&scoped=true&"
import script from "./UsersPrivilegeServicesReservations.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeServicesReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1031f7",
  null
  
)

export default component.exports